"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MessageCircleIcon = ({
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    xmlns: "http://www.w3.org/2000/svg",
    ...otherProps,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M57.023 60.76a1.827 1.827 0 113.653 0 1.827 1.827 0 01-3.653 0",
        fill: "#fefefe",
        className: "svg-fill-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M54.072 65.515a33.835 33.835 0 01-18.099 5.213c-18.777 0-33.999-15.222-33.999-34 0-18.777 15.222-34 33.999-34 18.776 0 34 15.223 34 34a33.842 33.842 0 01-6.871 20.496",
        stroke: "#fefefe",
        strokeWidth: 3.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#4caa50",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M50.384 40.013l9.335 3.586M49.068 43.44l5.312 2.04M47.752 46.866l1.68.645M40.861 49.21l-21.299-8.181a1.593 1.593 0 01-.915-2.057l5.312-13.83a1.593 1.593 0 012.057-.916l21.3 8.18a1.59 1.59 0 01.914 2.058l-5.312 13.83a1.593 1.593 0 01-2.057.916z",
        className: "svg-stroke-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M47.261 34.199l-12.855 3.13a1.973 1.973 0 01-2.095-.805l-7.454-10.93",
        stroke: "#4caa50",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-primary"
      })]
    })]
  });
};

MessageCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(MessageCircleIcon);

exports.default = _default;